import { render, staticRenderFns } from "./ml-models.vue?vue&type=template&id=0793084b&scoped=true"
import script from "./ml-models.vue?vue&type=script&lang=js"
export * from "./ml-models.vue?vue&type=script&lang=js"
import style0 from "./ml-models.vue?vue&type=style&index=0&id=0793084b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0793084b",
  null
  
)

export default component.exports